<!--
 * @ Author: Your name
 * @ Create Time: 2019-06-19 19:06:04
 * @ Modified by: Your name
 * @ Modified time: 2019-06-20 16:37:16
 * @ Description: 配送记录 -- 变更领取人 弹窗
 -->

<template>
  <div class="dialog-wrapper">
    <el-form :model="dialogFormData" label-width="108px" :rules="rules"
      label-position="right" ref="dialogForm"
      v-loading="formLoading" class="dialog-form" :inline="true">
      <div class="flex">
        <el-form-item label="变更前手机号">
          <el-input
            size="small" v-model="receivePersonPhone"
            placeholder="变更前手机号" disabled/>
        </el-form-item>
        <el-form-item label="变更后手机号" prop="exchangePhone">
          <el-input
            size="small" v-model="dialogFormData.exchangePhone"
            placeholder="变更后手机号" clearable />
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import dialog from '../../mixins/dialog'
import { correctPhone } from '../../libs/utils/validCheck'

export default {
  mixins: [dialog],
  props: {
    receivePersonPhone: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      USERTYPE: 2,
      FORBIDDENID: 1, // 禁用admin角色
      formLoading: false,
      dialogFormData: {
        exchangePhone: '',
        exchangeStatus: 2
      },
      rules: {
        exchangePhone: [{ required: true, message: '请输入修改领取人手机号', trigger: 'change' },
          { validator: correctPhone, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.dialog-wrapper{
  padding: 0px 35px;
  .flex{
    display: flex;
    height: 55px;
    justify-content: space-between;
  }
}
</style>
